export class entite{
    
    numEntite!: number;
    numPere!: entite;
    libelle!: string;
    adresse1!: string;
    adresse2!: string;
    adresse3!: string;
    codePostal!: string;
    ville!: string;
    type!: string;
    ext!:0;
    statut!:0;
    tel!: string;
    web!:string;
    user!: string;
    axe!: string;
    dc!: string;
    dm!: string;
    formeJuridique!: string;
    // constructor(num_pere: string,  libelle: string, adresse1: string, adresse2: string, adresse3: string, code_postal: string, ville: string, ext: number, tel: string,
    //   web: string,user: string,axe: string,formeJuridique: string)  { }

  }